import * as React from "react";

function SvgHeapanalyticsIcon(props, ref) {
  return (
    <svg height="1em" width="1em" viewBox="0 0 60 65" {...{ ...props, ref }}>
      <clipPath id="heapanalytics-icon_svg__a">
        <path d="M4.533 37.877v-21.76L23.38 5.233v21.762l18.848-10.88v21.76L23.38 48.76zm16.58-36.572L0 13.498v27L23.38 54l23.38-13.503v-27l-2.266-1.31L23.38 0z" />
      </clipPath>
      <linearGradient
        id="heapanalytics-icon_svg__b"
        gradientUnits="userSpaceOnUse"
        x1={23.333}
        x2={23.333}
        y1={54.002}
        y2={0.002}
      >
        <stop offset={0} stopColor="#f37c27" />
        <stop offset={1} stopColor="#ed3774" />
      </linearGradient>
      <path
        clipPath="url(#heapanalytics-icon_svg__a)"
        d="M0 0h46.762v54H0z"
        fill="url(#heapanalytics-icon_svg__b)"
        transform="matrix(1.18519 0 0 1.18519 4.29 0)"
      />
    </svg>
  );
}

export default React.forwardRef(SvgHeapanalyticsIcon);
